import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ExamStep.css';
const cx = classNames.bind(styles);

class ExamStep extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { active, title, stepType, sendReserve, sendFail, sendStop, stepComponent, eduStepStatus, isMobile } = this.props;

    return (
      <div className={cx('step-set')}>
        <div className={cx('step-inner')}>
          {stepType !== 'target' &&
            stepComponent !== 'eduSend' && (
              <Image
                className={cx('step-line')}
                src={'/img/exam/step/line' + (active ? '_' + stepType : '') + '.png'}
              />
            )}
          <Tooltip title={title} placement="bottom">
            <div className={cx('step-icon')}>
              {stepType === 'edu_progress' &&
                !!eduStepStatus && <div className={cx('edu-progress-step')}>{eduStepStatus}</div>}
              <Image
                className={cx('step-type')}
                src={
                  '/img/exam/step/' +
                  stepType +
                  (sendStop ? '_stop' : '') +
                  (sendReserve && !sendStop ? '_reserve' : '') +
                  (sendFail ? '_fail' : '') +
                  (active ? ( isMobile ? '_a_mobile' : '_a' ) : '') +
                  '.png'
                }
              />
              <Image
                className={cx('step-circle')}
                src={'/img/exam/step/circle' + (active ? '_' + stepType : '') + '.png'}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default injectIntl(ExamStep);



// WEBPACK FOOTER //
// ./src/script/components/common/ExamStep.js